import type { PositionSnapshot } from '@strategy4kids/protocol';
import type { GameAdapter } from './game-adapter.js';
import { indexToSquare } from './coords.js';

/**
 * Squares holding a piece the side to move can actually move (has at least one
 * legal destination). Pieces that are pinned or blocked are NOT included, which
 * is the point: the highlight answers "which of my pieces can I move?".
 */
export function movableSquares(adapter: GameAdapter, pos: PositionSnapshot): string[] {
  const out: string[] = [];
  for (let i = 0; i < 64; i++) {
    const sq = indexToSquare(i);
    const piece = adapter.pieceAt(pos, sq);
    if (piece && piece.color === pos.turn && adapter.legalMovesForSquare(pos, sq).length > 0) {
      out.push(sq);
    }
  }
  return out;
}
